<template>
  <div class="eventPlayersSchedule" v-if="list">
    <schedulePlayers_match_list
      :currCid="currCid"
      :currSid="currSid"
      :currThemeObj="currThemeObj"
      :data="list"
      :detailPathName="''"
      :chooseState="''"
      :themeClass="'onlyDisplay'"
    />
  </div>
</template>

<script>
// 分项运动员赛程 主题
import cup_base_data_mixin from '@mixins/cup_base_data'
import schedulePlayers_match_list from '@components/platfromBase/compreSportsMeet/schedulePlayers_match_list.vue'
export default {
  name: 'eventPlayersSchedule',
  mixins: [cup_base_data_mixin],
  components: {
    schedulePlayers_match_list,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
  },
  data() {
    return {
      sportsTypeArr: ['combat', 'uncombat'],
      list: null,
      //   testList: [
      //     {
      //       eventCode: 'SWMM50MBA-------------------------',
      //       organisationName: '中国',
      //       formatTime: '10:08',
      //       eventName: '男子50米仰泳',
      //       athletes: ['WANG Gukailai', 'XU Jiayu'],
      //       phaseCode: 'SWMM50MBA-------------HEAT--------',
      //       disciplineName: '游泳',
      //       phaseName: '预赛',
      //       formatTimes: [
      //         {
      //           competitorIds: [
      //             {
      //               competitorCode: '2008005',
      //               athletes: ['WANG Gukailai'],
      //             },
      //           ],
      //           formatTime: '10:08',
      //         },
      //         {
      //           competitorIds: [
      //             {
      //               competitorCode: '2008012',
      //               athletes: ['XU Jiayu'],
      //             },
      //           ],
      //           formatTime: '10:10',
      //         },
      //       ],
      //     },
      //     {
      //       eventCode: 'SWMW50MBA-------------------------',
      //       organisationName: '中国',
      //       formatTime: '10:16',
      //       eventName: '女子50米仰泳',
      //       athletes: ['WANG Xueer', 'WAN Letian'],
      //       phaseCode: 'SWMW50MBA-------------HEAT--------',
      //       disciplineName: '游泳',
      //       phaseName: '预赛',
      //       formatTimes: [
      //         {
      //           competitorIds: [
      //             {
      //               competitorCode: '2008008',
      //               athletes: ['WANG Xueer'],
      //             },
      //           ],
      //           formatTime: '10:16',
      //         },
      //         {
      //           competitorIds: [
      //             {
      //               competitorCode: '2008003',
      //               athletes: ['WAN Letian'],
      //             },
      //           ],
      //           formatTime: '10:18',
      //         },
      //       ],
      //     },
      //     {
      //       eventCode: 'SWMM50MFR-------------------------',
      //       organisationName: '中国',
      //       formatTime: '10:28',
      //       eventName: '男子50米自由泳',
      //       athletes: ['WANG Changhao', 'PAN Zhanle'],
      //       phaseCode: 'SWMM50MFR-------------HEAT--------',
      //       disciplineName: '游泳',
      //       phaseName: '预赛',
      //       formatTimes: [
      //         {
      //           competitorIds: [
      //             {
      //               competitorCode: '2008004',
      //               athletes: ['WANG Changhao'],
      //             },
      //           ],
      //           formatTime: '10:28',
      //         },
      //         {
      //           competitorIds: [
      //             {
      //               competitorCode: '2007996',
      //               athletes: ['PAN Zhanle'],
      //             },
      //           ],
      //           formatTime: '10:30',
      //         },
      //       ],
      //     },
      //     {
      //       eventCode: 'SWMW200MFR------------------------',
      //       organisationName: '中国',
      //       formatTime: '10:32',
      //       eventName: '女子200米自由泳',
      //       athletes: ['LI Bingjie', 'LIU Yaxin'],
      //       phaseCode: 'SWMW200MFR------------HEAT--------',
      //       disciplineName: '游泳',
      //       phaseName: '预赛',
      //       formatTimes: [
      //         {
      //           competitorIds: [
      //             {
      //               competitorCode: '2007986',
      //               athletes: ['LI Bingjie'],
      //             },
      //           ],
      //           formatTime: '10:32',
      //         },
      //         {
      //           competitorIds: [
      //             {
      //               competitorCode: '2007992',
      //               athletes: ['LIU Yaxin'],
      //             },
      //           ],
      //           formatTime: '10:40',
      //         },
      //       ],
      //     },
      //   ],
    }
  },
  watch: {
    datas(newVal, oldVal) {
      if (
        newVal &&
        JSON.stringify(newVal.data.dataList) !==
          JSON.stringify(oldVal.data.dataList)
      ) {
        this.list = this.computedMatchList(newVal.data.dataList)
        // this.list = this.computedMatchList(this.testList)
      }
    },
    immediate: false,
    deep: true,
  },
  created() {
    this.list = this.computedMatchList(this.datas.data.dataList)
    // this.list = this.computedMatchList(this.testList)
  },
  methods: {
    computedMatchList(list) {
      let matchList = []
      if (list && list.length > 0) {
        matchList = list.map((item) => {
          let newItem = {}
          newItem.matchTime = item.formatTime
          newItem.matchName = `${item.disciplineName}·${item.eventName}${item.phaseName}`
          newItem.isChina = true
          newItem.phaseCode = item.phaseCode
          newItem.chooseId = item.phaseCode
          newItem.channels = item.channels
          // newItem.competitorArr = item.competitors.map(
          //   (competitorItem, competitorIndex) => {
          //     let competitorName = ''
          //     if (
          //       competitorItem.athletes &&
          //       competitorItem.athletes.length > 0 &&
          //       competitorItem.athletes.length < 5
          //     ) {
          //       const athletesArr = []
          //       competitorItem.athletes.forEach((playerItem) => {
          //         athletesArr.push(playerItem.playerName)
          //       })
          //       competitorName = athletesArr.join('/')
          //     } else {
          //       competitorName = competitorItem.organisationName
          //     }
          //     return {
          //       value: competitorItem.competitorCode,
          //       competitorName,
          //       act: competitorIndex === 0,
          //       rankNum: competitorItem.rankNum,
          //       resultValue: competitorItem.resultValue,
          //     }
          //   }
          // )
          /**
           * electType：scheduleCode，一般competitorCodes里会有两个对象，第一个是主队第二个是客队，
           * 应当展示一条，athletes的个数大于2显示运动员名称，其余显示organisationName，
           * 结构如下图，应显示：美国 6 : 5 ROC
           */
          newItem.competitorArr = item.selectCompetitors.map(
            (selectCompetitor) => {
              const competitors = selectCompetitor.competitors
              let showContent = ''
              if (selectCompetitor.selectType === 'scheduleCode') {
                const mainCompetitor = competitors[0]
                const guestCompetitor = competitors[1]
                let mainName = ''
                let guestName = ''
                if (
                  mainCompetitor.athletes &&
                  mainCompetitor.athletes.length > 0 &&
                  mainCompetitor.athletes.length < 5
                ) {
                  mainName = `${mainCompetitor.athletes
                    .map((item) => item.playerName)
                    .join('/')}`
                } else {
                  mainName = mainCompetitor.organisationName
                }
                if (
                  guestCompetitor.athletes &&
                  guestCompetitor.athletes.length > 0 &&
                  guestCompetitor.athletes.length < 5
                ) {
                  guestName = `${guestCompetitor.athletes
                    .map((item) => item.playerName)
                    .join('/')}`
                } else {
                  guestName = guestCompetitor.organisationName
                }
                if (mainCompetitor.resultValue && guestCompetitor.resultValue) {
                  showContent = `${mainName} ${mainCompetitor.resultValue}-${guestCompetitor.resultValue} ${guestName}`
                } else {
                  showContent = `${mainName} VS ${guestName}`
                }
              } else if (selectCompetitor.selectType === 'competitorCode') {
                const competitor = competitors[0]
                let name = ''
                if (
                  competitor.athletes &&
                  competitor.athletes.length > 0 &&
                  competitor.athletes.length < 5
                ) {
                  name = `${competitor.athletes
                    .map((item) => item.playerName)
                    .join('/')}`
                } else {
                  name = competitor.organisationName
                }
                showContent = `${name}( 排名：${competitor.rankNum} 成绩：${competitor.resultValue} )`
              }

              return {
                selectType: selectCompetitor.selectType,
                value: selectCompetitor.selectCode,
                showContent,
                act: false, //最新逻辑默认全部不选中， 之前旧逻辑 competitorIndex === isDefaultActCompetitorsIndex,
              }
            }
          )
          newItem.sportsId = item.disciplineCode
          newItem.sportsName = item.disciplineName
          newItem.eventId = item.eventCode
          newItem.eventName = item.eventName
          newItem.formatTime = item.formatTime
          newItem.formatDate = item.formatDate
          newItem.delegationName = item.organisationName
          newItem.delegationId = item.organisationCode
          return newItem
        })

        // console.debug(
        //   'computedMatchList end:',
        //   labelObj,
        //   matchList,
        //   matchLabelArr
        // )
      }
      console.debug('computedMatchList:', matchList)
      return matchList
    },
  },
}
</script>

<style lang="scss" scoped>
.eventPlayersSchedule {
  width: 100%;
}
</style>
